import { booleanAttribute, Component, input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "a[vds-sub-nav-item], button[vds-sub-nav-item]",
    templateUrl: "./nav-item.component.html",
    styleUrl: "./nav-item.component.css",
    encapsulation: ViewEncapsulation.None,
    host: {
        class: "group vds-sub-nav-item",
        "[class.vds-sub-nav-item--active]": "active()"
    },
    standalone: true
})
export class VdsNavItemComponent {
    public active = input(false, { transform: booleanAttribute });
}
